import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';

const EmployerViewController =()=>{
    const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};
    const getEmployer = () => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.get(`${BASE_URL}employer/`);
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "GET_EMPLOYERS_SUCCESS", payload: data });
          dispatch({ type: "LOADING", payload: false });
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          const message = getErrorMessage(error);
          dispatch({
            type: "GET_EMPLOYERS_FAILURE",
            payload: { error: error },
          });
          toast.error(message);
        }
      };
    
      const addEmployer = (reqData) => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.post(
            `${BASE_URL}employer/`,
            reqData
          );
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "ADD_EMPLOYER_SUCCESS", payload: data });
          dispatch(getEmployer());
          dispatch({ type: "LOADING", payload: false });
          toast.success("Employer added sucessfully");
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          const message = getErrorMessage(error);
          dispatch({
            type: "ADD_EMPLOYER_FAILURE",
            payload: { error: error },
          });
          toast.error(message);
        }
      };
    
      const updateEmployer = (employeeId, reqData) => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.put(
            `${BASE_URL}employer/${employeeId}/`,
            reqData
          );
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "UPDATE_EMPLOYER_SUCCESS", payload: data });
          dispatch(getEmployer());
          dispatch({ type: "LOADING", payload: false });
          toast.success("Employer updated sucessfully");
          return true;
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          const message = getErrorMessage(error);
          dispatch({
            type: "UPDATE_EMPLOYER_FAILURE",
            payload: { error: error },
          });
          toast.error(message);
        }
      };
    
      const deleteEmployer = (employerId) => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.delete(
            `${BASE_URL}employer/${employerId}/`
          );
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "DELETE_EMPLOYER_SUCCESS", payload: data });
          dispatch(getEmployer());
          dispatch({ type: "LOADING", payload: false });
          toast.success("Employer deleted sucessfully");
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          const message = getErrorMessage(error);
          dispatch({
            type: "DELETE_EMPLOYER_FAILURE",
            payload: { error: error },
          });
          toast.error(message);
        }
      };
      
      const getAllEmployeeEmployer = () => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.get(`${BASE_URL}employer-employee/`);
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "GET_ALL_EMPLOYEE_EMPLOYERS_SUCCESS", payload: data });
          dispatch({ type: "LOADING", payload: false });
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          const message = getErrorMessage(error);
          dispatch({
            type: "GET_ALL_EMPLOYEE_EMPLOYERS_FAILURE",
            payload: { error: error },
          });
          toast.error(message);
        }
      };



    return{getEmployer, addEmployer, deleteEmployer, updateEmployer,getAllEmployeeEmployer  };
};

export default EmployerViewController;

